<template>
  <div
    @click="$emit('onClick')"
    :class="[
      'switcher',
      {
        switcher_active: isActive,
      },
    ]"
  >
    <div
      :class="[
        'switcher-ball',
        {
          'switcher-ball_active': isActive,
        },
      ]"
    />
  </div>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
  },
};
</script>

<style scoped>
.switcher {
  flex-shrink: 0;
  position: relative;
  width: 28px;
  height: 16px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--white-color);
  cursor: pointer;
  transition: background-color 0.15s ease-out;
}
.switcher_active {
  background: var(--secondary-color);
}
.switcher-ball {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--border-color);
  transition: background-color 0.15s ease-out, left 0.15s ease-out;
}
.switcher-ball_active {
  left: 14px;

  background: var(--white-color);
}
</style>
